export function requireNonEmptyString(value, label) {
    const normalized = value == null ? '' : String(value).trim();
    if (normalized === '') {
        throw new Error('ids: ' + label + ' is required');
    }
    return normalized;
}

export function requireRowKey(key, caller) {
    if (!key || typeof key !== 'object') {
        throw new Error(caller + ': row key is required');
    }
    const type = requireNonEmptyString(key.type, 'key.type');
    const id = requireNonEmptyString(key.id, 'key.id');
    if (type !== 'pledge' && type !== 'member') {
        throw new Error(caller + ': unsupported row key type "' + type + '"');
    }
    return {
        type,
        id,
        tableName: key.tableName == null ? '' : String(key.tableName),
    };
}

export default {
    getDetailRowId(key) {
        const rowKey = requireRowKey(key, 'getDetailRowId');
        if (rowKey.type === 'pledge' && rowKey.tableName !== '') {
            return 'pledge-detail-' + rowKey.tableName + '-' + rowKey.id;
        }
        if (rowKey.type === 'pledge') {
            return 'pledge-detail-' + rowKey.id;
        }
        return 'member-detail-' + rowKey.id;
    },

    getSpacerPrefix(key) {
        const rowKey = requireRowKey(key, 'getSpacerPrefix');
        if (rowKey.type === 'pledge' && rowKey.tableName !== '') {
            return rowKey.type + '-' + rowKey.tableName + '-' + rowKey.id;
        }
        return rowKey.type + '-' + rowKey.id;
    },

    getDetailId(pledgeId, tableName) {
        const id = requireNonEmptyString(pledgeId, 'pledgeId');
        const table = tableName == null ? '' : String(tableName).trim();
        return table !== '' ? table + '-' + id : id;
    },

    getPaymentDetailsId(pledgeId, tableName) {
        return 'payment-details-' + this.getDetailId(pledgeId, tableName);
    },
};
